import { Link } from 'react-router-dom';
import SEOHead from '../../components/SEOHead';

interface Product {
  id: number;
  name: string;
  description: string;
  price: string;
  image: string;
  amazonLink: string;
}

const products: Product[] = [
  {
    id: 1,
    name: "Bissell Little Green Multi-Purpose Cleaner",
    description: "The #1 best-selling portable carpet and upholstery cleaner. It is famous for erasing pet stains and refreshing sofas.",
    price: "$123.59",
    image: "https://static.readdy.ai/image/918694c0b33b18123a4b53c7a1500734/7a62e118b21695244c955776a0fdbeaa.png",
    amazonLink: "https://amzn.to/3NJGeKy"
  },
  {
    id: 2,
    name: "Fullstar Vegetable Chopper",
    description: "A viral kitchen prep tool that dices vegetables in seconds. It has over 100,000 5-star reviews for saving time on meal prep.",
    price: "$29.99",
    image: "https://static.readdy.ai/image/918694c0b33b18123a4b53c7a1500734/73a758c9c9480ea2283f0e4c8a011820.png",
    amazonLink: "https://amzn.to/3Zbg2Lp"
  },
  {
    id: 3,
    name: "Beckham Hotel Collection Bed Pillows (Set of 2)",
    description: "Consistently the top-selling pillow on Amazon, known for its gel-filled, down-alternative cooling comfort at an affordable price.",
    price: "$39.99",
    image: "https://static.readdy.ai/image/918694c0b33b18123a4b53c7a1500734/cf1e7460328a69563b8c1776d767ca06.png",
    amazonLink: "https://amzn.to/49pJxiA"
  },
  {
    id: 4,
    name: "Owala FreeSip Water Bottle",
    description: "The \"It\" water bottle of the year. Its unique spout lets you sip upright or tilt back to chug, and it is leak-proof.",
    price: "$27.99",
    image: "https://static.readdy.ai/image/918694c0b33b18123a4b53c7a1500734/8eb8cf82987dce7107b907a7e2c6b184.png",
    amazonLink: "https://amzn.to/49q5372"
  },
  {
    id: 5,
    name: "ChomChom Pet Hair Remover",
    description: "A reusable lint roller that requires no sticky tape. It is widely considered the best tool for removing dog and cat hair from furniture.",
    price: "$29.95",
    image: "https://static.readdy.ai/image/918694c0b33b18123a4b53c7a1500734/c40d0172f29ceb4f7c1a71d71abd6be1.png",
    amazonLink: "https://amzn.to/3ZdEpIp"
  },
  {
    id: 6,
    name: "Rubbermaid Brilliance Storage Containers",
    description: "Crystal-clear, stain-proof, and airtight containers that have become the gold standard for pantry organization.",
    price: "$44.99",
    image: "https://static.readdy.ai/image/918694c0b33b18123a4b53c7a1500734/14e083a1bdf05a28471db67d45e0b1ac.png",
    amazonLink: "https://amzn.to/4qzThg8"
  },
  {
    id: 7,
    name: "Stardrops - The Pink Stuff",
    description: "A \"miracle\" cleaning paste from the UK that went viral on TikTok for removing rust, grime, and permanent marker from almost any surface.",
    price: "$5.97",
    image: "https://static.readdy.ai/image/918694c0b33b18123a4b53c7a1500734/207a4a553f66b134cdc898bc9a1dcf36.png",
    amazonLink: "https://amzn.to/4sJc8qE"
  },
  {
    id: 8,
    name: "Souper Cubes Freezing Trays",
    description: "Silicone trays that freeze leftovers (soup, broth, sauce) into perfect 1-cup portions, making meal prep significantly easier.",
    price: "$19.95",
    image: "https://static.readdy.ai/image/918694c0b33b18123a4b53c7a1500734/b0c6d777c446db0eec6ff2c6c3e21355.png",
    amazonLink: "https://amzn.to/4pKXsEF"
  },
  {
    id: 9,
    name: "Maldon Smoked Sea Salt Flakes",
    description: "A gourmet finishing salt that chefs and home cooks swear by to elevate simple dishes like eggs, steaks, and avocado toast.",
    price: "$8.49",
    image: "https://static.readdy.ai/image/918694c0b33b18123a4b53c7a1500734/af75f1610d7d5145f749f58ffe2cd4c2.png",
    amazonLink: "https://amzn.to/4qPm1kS"
  },
  {
    id: 10,
    name: "Scrub Daddy Sponge (3-Pack)",
    description: "The smiling sponge that changes texture based on water temperature (soft in warm, firm in cold) remains a massive best-seller.",
    price: "$11.98",
    image: "https://static.readdy.ai/image/918694c0b33b18123a4b53c7a1500734/cb2f733774c4df5d99379ca7c92ca615.png",
    amazonLink: "https://amzn.to/3NwgrFE"
  }
];

export default function HomeFindsPage() {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": "Home Finds - Everyday Essentials",
    "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/home-finds`,
    "description": "Curated essentials to make your space feel like home. Top-rated home products including cleaning tools, kitchen gadgets, and organization solutions.",
    "mainEntity": {
      "@type": "ItemList",
      "itemListElement": products.map((product, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "item": {
          "@type": "Product",
          "name": product.name,
          "description": product.description,
          "offers": {
            "@type": "Offer",
            "price": product.price.replace('$', ''),
            "priceCurrency": "USD",
            "availability": "https://schema.org/InStock",
            "url": product.amazonLink
          }
        }
      }))
    }
  };

  return (
    <>
      <SEOHead
        title="Home Finds - Curated Home Essentials & Organization Products"
        description="Discover top-rated home essentials including Bissell Little Green Cleaner, Fullstar Vegetable Chopper, ChomChom Pet Hair Remover, and more. Curated products to make your space feel like home."
        keywords="home finds, home essentials, kitchen gadgets, cleaning tools, organization products, home products, amazon home finds"
        canonicalPath="/home-finds"
        schemaData={schemaData}
      />
      <div className="min-h-screen w-full animated-gradient px-4 py-12">
        <div className="w-full max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <Link 
              to="/" 
              className="inline-flex items-center gap-2 text-white/90 hover:text-white mb-6 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line text-2xl"></i>
              <span className="text-lg">Back to Home</span>
            </Link>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4">
              🛍 Home Finds
            </h1>
            <p className="text-white/90 text-lg md:text-xl">
              Curated essentials to make your space feel like home
            </p>
          </div>

          {/* Products Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
            {products.map((product) => (
              <div 
                key={product.id}
                className="bg-white/95 backdrop-blur-sm rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 flex flex-col"
              >
                <div className="w-full h-64 overflow-hidden">
                  <img 
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-6 flex flex-col flex-grow">
                  <h3 className="text-xl font-bold text-gray-800 mb-3">{product.name}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed mb-4 flex-grow">{product.description}</p>
                  <div className="flex items-center justify-end mt-auto">
                    <a
                      href={product.amazonLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bg-gradient-to-r from-[#4a8b8f] to-[#5a9b9f] hover:from-[#3a7b7f] hover:to-[#4a8b8f] text-white font-semibold py-3 px-6 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center gap-2 whitespace-nowrap cursor-pointer"
                    >
                      <span>View on Amazon</span>
                      <i className="ri-amazon-fill text-xl"></i>
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Footer */}
          <div className="text-center space-y-4">
            <p className="text-white/90 text-sm md:text-base">
              As an Amazon Associate, I earn from qualifying purchases support the hustle 💋
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
